var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPbsKidsLogo = function SvgPbsKidsLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    fill: "none",
    viewBox: "0 0 101 101",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50 .8C22.385.8 0 23.186 0 50.8s22.385 50 50 50 50-22.385 50-50S77.61.8 50 .8",
    style: {
      fill: "#2638c4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "letters-group letters-pbs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.412 22.829c9.138-2.248 16.136 1.081 17.698 8.365 1.516 7.084-2.88 13.819-11.182 15.859l-2.106.462s.933 4.634 1.806 9.991a89 89 0 0 1-8.864 1.894c-1.279-10.761-3.656-22.539-6.856-33.093 2.304-1.224 6.234-2.676 9.509-3.472zm4.02 16.902c4.198-1.027 5.889-3.218 5.261-6.112-.597-2.797-3.031-4.341-6.304-3.543-.653.163-2.203.706-2.203.706l1.964 9.157q.648-.057 1.282-.211",
    className: "pbs-p",
    style: {
      fill: "#99cf16"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.621 36.874c3.407 1.582 5.086 4.011 5.084 8.015 0 6.378-5.651 10.799-13.194 10.806-6.043 0-9.926-.695-12.076-1.276.964-10.13.964-22.707-.267-33.798a44.8 44.8 0 0 1 11.397-1.542c7.957 0 12.403 4.109 12.407 10.271 0 1.4-.533 5.867-3.357 7.524zm-11.654-9.963s.209 3.333.209 7.083c3.385.745 7.1-.038 7.1-3.509s-3.258-4.546-7.309-3.574m8.227 17.71c0-3.564-4.18-4.445-8.023-3.717 0 4.028-.267 7.204-.267 7.204 4.078.814 8.29.078 8.29-3.487",
    className: "pbs-b",
    style: {
      fill: "#99cf16"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.136 33.978c-5.681-4.845-9.608-3.224-9.908-1.442-.267 1.557 1.111 2.778 4.422 4.218 3.839 1.674 9.237 4.592 8.222 11.45-.948 6.46-6.242 10.47-13.11 9.532-4-.548-8.263-2.851-10.833-5.955 0 0 .735-1.202 2.304-3.046 1.528-1.806 2.838-3.056 2.838-3.056 1.805 2.106 4.583 4.102 7.161 4.377 3.194.34 5.204-3.428.151-5.603-7.083-3.047-10.544-6.459-9.816-12.152.883-6.812 6.388-11.09 13.687-9.73 5.875 1.089 9.904 5.304 9.904 5.304s-.694 1.296-2.166 3.211c-1.473 1.915-2.856 2.892-2.856 2.892",
    className: "pbs-s",
    style: {
      fill: "#99cf16"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "letters-group letters-kids"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.125 81.031c-1.039.307-2.1.533-3.174.676-.596.083-1.707.212-2.25.261a36 36 0 0 0-3.297-3.083 60 60 0 0 0-3.522-2.706c-.3.334-.663.728-.972 1.015.495 2.828.955 6.016.955 6.016-.669.237-1.357.421-2.055.548q-1.064.193-2.144.223s-.489-3.827-1.438-9.146c-.95-5.32-1.813-8.568-1.813-8.568q.978-.353 2.001-.539a15 15 0 0 1 2.202-.232s.782 3.348 1.457 7.025c2.097-2.383 3.525-4.861 4.898-8.277a27 27 0 0 1 2.099-.47 23 23 0 0 1 2.849-.353 37.7 37.7 0 0 1-5.249 9.505 50 50 0 0 1 4.465 3.416c2.578 2.191 4.988 4.689 4.988 4.689",
    className: "kids-k",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.011 80.892s.039-4.97-.182-9.564a223 223 0 0 0-.569-8.431 10.3 10.3 0 0 1 2.083-.255 12 12 0 0 1 2.183.076s.332 3.104.568 8.432.184 9.564.184 9.564q-1.032.212-2.084.255-1.094.043-2.183-.077",
    className: "kids-i",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.301 71.725c-.122 5.928-4.351 9.467-10.654 9.336a43 43 0 0 1-6.01-.489s.334-3.889.45-9.205c.117-5.317-.08-8.717-.08-8.717 1.494-.222 3.304-.382 5.94-.326 6.79.143 10.469 3.893 10.354 9.402zm-4.7-.039c.067-3.232-1.868-5.351-5.535-5.426-.573-.011-1.175-.024-1.834.018 0 0 .171 2.083.091 5.266a82 82 0 0 1-.313 5.521c.629.042 1.259.082 1.944.097 3.526.074 5.578-2.076 5.647-5.474zm5.87 7.803",
    className: "kids-d",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.471 79.489a10.2 10.2 0 0 1 2.564-2.917c1.005 1.163 2.749 2.264 4.861 2.664 2.026.385 2.936-.101 3.118-1.068.173-.911-.178-1.521-3.209-2.917-2.905-1.293-5.361-2.959-4.715-6.527.643-3.396 3.815-5.056 7.982-4.267 3.126.592 5.022 1.981 5.935 3.011a6.47 6.47 0 0 1-2.575 2.972 8.3 8.3 0 0 0-4.357-2.254c-1.667-.314-2.677.122-2.834.95-.168.885.155 1.346 3.246 2.731 3.223 1.468 5.264 3.314 4.723 6.498-.642 3.854-3.775 5.463-8.112 4.642-3.634-.69-5.662-2.304-6.627-3.517z",
    className: "kids-s",
    style: {
      fill: "#fff"
    }
  })));
};
export default SvgPbsKidsLogo;